import { Link } from 'react-router-dom';
import { getCategoryName, formatCount } from '@/lib/content';
import type { Article } from '@/types/content';

interface ArticleListItemProps {
  article: Article;
  index?: number;
}

export default function ArticleListItem({ article, index }: ArticleListItemProps) {
  return (
    <article className="group flex items-center gap-4 border-b border-background-200 py-4 last:border-b-0">
      {typeof index === 'number' && (
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base text-background-50 bg-primary-500 dark:text-foreground-950">
          {index + 1}
        </span>
      )}
      <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-100 md:h-20 md:w-28">
        <img
          src={article.cover}
          alt={`${article.title} 相关插画`}
          title={`${article.title} - 猎奇吃瓜`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 md:text-base">
          <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-700">
            {article.title}
          </Link>
        </h3>
        <p className="mt-1 line-clamp-2 hidden text-xs leading-relaxed text-foreground-600 sm:block">
          {article.excerpt}
        </p>
        <div className="mt-1.5 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="text-secondary-700">{getCategoryName(article.category)}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {formatCount(article.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line" aria-hidden="true"></i>
            {formatCount(article.likes)}
          </span>
        </div>
      </div>
    </article>
  );
}